import { gql } from '@apollo/client';

/**
 * The full company-profile shape for the Company Portal (admin `CompanyFields` plus the
 * profile fields — mission/vision/culture/benefits/contact/social links). Kept separate from the
 * admin fragment so admin tables don't over-fetch; Apollo still normalizes both into the same
 * cache entry by `id`, so a portal profile edit updates admin views too (§5.3/§5.5).
 */
export const COMPANY_PROFILE_FIELDS = gql`
  fragment CompanyProfileFields on Company {
    id
    name
    code
    description
    website
    industry
    size
    logoUrl
    mission
    vision
    culture
    benefits
    contact {
      email
      phone
      addressLine1
      addressLine2
      city
      state
      country
      postalCode
    }
    socialLinks {
      platform
      url
    }
    createdAt
    updatedAt
  }
`;

/** One row of the portal invitation table. `status` is the server-computed EFFECTIVE status —
 * a lapsed Pending row already comes back EXPIRED (lazy expiry), so the UI never re-derives it. */
export const COMPANY_INVITATION_FIELDS = gql`
  fragment CompanyInvitationFields on CompanyInvitation {
    id
    companyId
    email
    role
    status
    invitedBy
    invitedAt
    expiresAt
    acceptedAt
    respondedAt
    createdAt
    updatedAt
  }
`;
